import { FETCH_TRAILS_START } from 'actions/trails';

export default function fetchTrailsStart() {
  return {
    type: FETCH_TRAILS_START,
  };
}
